export type TGetCourseListResponse = {
  courseId: number;
  courseName: string;
}[];

export type TGetCourseInfoListResponse = {
  courseInfoId: number;
  courseName: string;
}[];

export type TGetStudClassListResponse = {
  courseInfoId: number;
  studClass: string;
}[];

export type TGetChartRoundResponse = {
  chartRound: number;
  registeredChartName: string;
  submitPeriod: string;
}[];

export type TGetStudentUserListResponse = {
  studentUserId: number;
  loginId: string;
  studentName: string;
}[];

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}
